<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2BIxUF/tc-custom/9781429984959.jpg?1732049222769" alt="This image is the cover for the book Pursuit of Other Interests"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pursuit of Other Interests
      </h1>
      <p class="bookDescription body article font2">
        <p>Charlie Baker is a neurotic but charming 50-year-old workaholic CEO of a major Chicago ad agency who seems to have it all: an impressive house in an upscale suburb, an equally impressive salary, the requisite pretty wife and accomplished son. All of this comes crashing down when Charlie is unceremoniously fired. In an instant, his life is transformed from corporate titan to just another out of work American.<br/><br/>For Charlie—an admitted workaholic—a world without a job is a strange world indeed. Rather than tell his family, every morning Charlie leaves home to spend his days at an outplacement firm, where he meets a cast of equally desperate corporate misfits. As Charlie reluctantly embarks on a journey of self-discovery, he finds out what happens when his work life is lost and his real life begins. <br/><br/>Humorous, poignant, and honest, <i>The Pursuit of Other Interests </i>offers a glimpse into the lives, hearts, and minds of the 21st-century American family.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Kokoris
      </h2>
      
      <p class="authorDescription body article"><P>JIM KOKORIS's work has appeared in the <I>Chicago</I><I> Tribune Sunday Magazine, USA Weekend, Chicago Sun-Times</I>, and <I>Reader's Digest</I>. He is the author of the novels <I>The Rich Part of Life</I>, which has been published in 15 languages and for which he won a Friends of American Writers Award for Best First Novel, and <I>Sister North</I>. A graduate of the University of Illinois, Jim lives with his wife and their three sons in the Chicago area.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c3f99d3c